module.exports = __webpack_public_path__ + "img/man_hand.40c8756d.png";